
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PricingFeature {
  text: string;
}

interface PricingPlanProps {
  name: string;
  price: string;
  originalPrice?: string;
  period?: string;
  description: string;
  features: PricingFeature[];
  highlight?: boolean;
  highlightText?: string;
  savingsText?: string;
  trialText?: string;
}

const PricingPlan = ({
  name,
  price,
  originalPrice,
  period,
  description,
  features,
  highlight = false,
  highlightText = "BEST DEAL",
  savingsText,
  trialText,
}: PricingPlanProps) => {
  const buttonText = trialText ? "Start 30-Day Free Trial" : "Get Started";
  
  return (
    <div className={`bg-card p-8 rounded-lg border ${highlight ? 'border-godyspo-gold relative hover:shadow-lg hover:shadow-godyspo-gold/10' : 'border-border hover:border-godyspo-gold/50'} transition-all`}>
      {highlight && (
        <div className="absolute -top-3 left-0 right-0 text-center">
          <span className="bg-godyspo-gold text-godyspo-background px-4 py-1 text-xs font-bold rounded">
            {highlightText}
          </span>
        </div>
      )}
      <h3 className="text-xl font-bold mb-1">{name}</h3>
      <div className="flex flex-wrap items-baseline">
        {originalPrice && <span className="text-xl font-medium text-muted-foreground line-through mr-2">{originalPrice}</span>}
        <span className="text-3xl font-bold">{price}</span>
        {period && <span className="text-muted-foreground ml-1">{period}</span>}
      </div>
      
      {trialText && <p className="text-sm text-godyspo-gold mb-1">{trialText}</p>}
      {savingsText && <p className="text-sm text-godyspo-gold mb-1">{savingsText}</p>}
      
      <p className="text-sm text-muted-foreground mb-6">
        {description}
      </p>
      
      <ul className="space-y-4 mb-8">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <CheckCircle className="h-5 w-5 text-godyspo-gold mr-2 shrink-0" />
            <span>{feature.text}</span>
          </li>
        ))}
      </ul>
      
      <Link to="/register">
        <Button className="w-full bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90">
          {buttonText}
        </Button>
      </Link>
    </div>
  );
};

export default PricingPlan;
